import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  validationKey;
  languageCode;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, public appConfig: AppConfig ) { }

  ngOnInit() {
   this.validationKey = this.activatedRoute.snapshot.params.validationKey;
   this.languageCode = this.activatedRoute.snapshot.params.languageCode;
  
  }
  onSubmitSuccess(event){
    this.router.navigate(['login']);
    
  }
}
